import { useEffect } from 'react'
import { useSearchBox } from 'react-instantsearch'
import { evaluateSearch } from './engine'

// Wait until the query has been stable for this long before evaluating,
// so partial input ("hea...") never triggers an egg mid-typing.
const settleMs = 800

/**
 * Renders nothing - mount it in a search widget's result list (below the
 * InstantSearch provider), in both the results and the no-results branch.
 * While mounted it reports the current query and result state to the
 * easter egg engine, which decides per egg whether it may fire.
 */
export default function SearchEasterEgg({
  source,
  noResults
}: {
  source: string
  noResults: boolean
}) {
  const { query } = useSearchBox()

  useEffect(() => {
    const trimmed = query.trim()
    if (!trimmed) return
    const timeout = setTimeout(
      () => evaluateSearch({ source, query: trimmed, noResults }),
      settleMs
    )
    return () => clearTimeout(timeout)
  }, [query, source, noResults])

  return null
}
